import React from 'react';
import { FadeIn } from './FadeIn';
export function ProofSection() {
  return <section className="relative z-10 py-20 px-4" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <FadeIn className="relative" data-id="element-142">
          {/* Large decorative quotes */}
          <div className="absolute -top-10 -left-6 text-8xl text-blue-500/10 font-serif leading-none pointer-events-none select-none" data-id="element-143">
            "
          </div>
          <div className="absolute -bottom-20 -right-6 text-8xl text-blue-500/10 font-serif leading-none pointer-events-none select-none" data-id="element-144">
            "
          </div>

          <div className="glass-card p-8 md:p-12 text-center border-amber-500/20 bg-gradient-to-b from-white/5 to-transparent" data-id="element-145">
            <p className="text-xl md:text-2xl text-gray-200 leading-relaxed font-serif italic" data-id="element-146">
              En solo 7 días aplicando este protocolo, tu sistema nervioso
              dejará de asociar la cama con un campo de batalla. Pasarás de
              "pelear por dormir" a simplemente permitir que el sueño suceda,
              despertando con una{' '}
              <strong className="text-amber-400 font-bold not-italic" data-id="element-147">
                claridad mental
              </strong>{' '}
              que no has sentido en años.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}